import { Routes } from '@angular/router';
import { slugPageResolver } from '@pages/slug-page/resolvers';

export const APP_ROUTES: Routes = [
  {
    path: 'middle',
    loadComponent: () => import('@pages/middle-office').then((m) => m.MiddleOfficeComponent),
  },
  {
    path: '**',
    resolve: { pageData: slugPageResolver },
    loadComponent: () => import('@pages/slug-page').then((m) => m.SlugPageComponent),
  },
];
